import React from 'react';
import styled from 'styled-components';
import NumericInputChangeGuard from './NumericInputChangeGuard';
import {getPriorYearMateriality} from '../../../selectors/Ares/materiality';
import {useSelector} from 'react-redux';
import {isNullOrUndefined, setThousandSeparator} from '../../../util/utils';
import NumberFormat from 'react-number-format';

function NumericInputWithPriorPeriodLabel({
	priorPeriodLabel,
	priorPeriodAmount,
	id,
	name,
	bodyId,
	label,
	onAccept,
	suffix,
	prefix,
	isDecimal,
	initialValue,
	isDisabled
}) {
	const showPriorPeriodLabel = useSelector((store) => getPriorYearMateriality(store));
	const userPreferences = useSelector((state) => state.userPreferences);

	return (
		<StyledNumericInputWithPriorPeriodLabel className="StyledNumericInputWithPriorPeriodLabel">
			{showPriorPeriodLabel && !isNullOrUndefined(priorPeriodAmount) && (
				<span className="prior-period-amount">
					<p className="priorPeriodAmountLabel">{priorPeriodLabel}: </p>
					<NumberFormat
						className="priorPeriodAmountValue"
						value={priorPeriodAmount}
						decimalScale={isDecimal ? 1 : 0}
						displayType="text"
						suffix={suffix}
						prefix={prefix}
						{...setThousandSeparator(userPreferences.numberFormat)}
					/>
				</span>
			)}
			<NumericInputChangeGuard
				showLabel
				id={id}
				name={name}
				bodyId={bodyId}
				label={label}
				maxLength={15}
				onAccept={onAccept}
				initialValue={initialValue}
				disabled={isDisabled}
			/>
		</StyledNumericInputWithPriorPeriodLabel>
	);
}

NumericInputWithPriorPeriodLabel.defaultProps = {
	suffix: '',
	prefix: '',
	isDecimal: false
};

export default NumericInputWithPriorPeriodLabel;

const StyledNumericInputWithPriorPeriodLabel = styled.section`
	padding: var(--px-24);
	border-radius: var(--px-12) !important;
	border: var(--px-1) solid var(--neutrals-200);
	background-color: var(--neutrals-00white);
	.prior-period-amount {
		display: inline-block;
		margin-bottom: var(--px-24);
		.priorPeriodAmountLabel {
			font-size: var(--px-16);
			font-weight: 300;
			line-height: var(--px-24);
			color: var(--neutrals-900);
			display: inline;
		}
		.priorPeriodAmountValue {
			font-size: var(--px-16);
			font-weight: 600;
			line-height: var(--px-24);
			color: var(--neutrals-900);
			display: inline;
		}
	}
`;
